import React, { useEffect, useState } from 'react';
import { unionFlag, getSessonStorage } from '@/utils';
import { withRouter } from 'umi';
import { connect } from 'dva';
import {TLang, ReplaceText} from '@/utils/lang';
import styles from './index.less';
const DFfudouImg = require('@/assets/imgs/fudou.png');

export interface Props {
  time?: string;
}

const DFTipsMsg = (props: Props) => {
  const { time } = props;
  const [showMsg, setShowMsg] = useState(false);
  const [msgText, setMsgText] = useState('');
  useEffect(() => {
    if (time) {
      // 结束时间
      const lastTime = time.replace(/-/g, '/').replace(/T/, ' ');
      const lastDate = new Date(lastTime);
      const nowDate = new Date();
      const dateDiff = lastDate.getTime() - nowDate.getTime();//时间差的毫秒数
      const minutes = Math.floor(dateDiff / (60 * 1000));//计算相差分钟数
      if (minutes <= 15) {
        let str;
        if (minutes > 0) {
          // 临近开场提醒：您选购的场次将在X分钟内开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次
 str = <div className={styles.tipsmsg}>
   {TLang('临近开场提醒：您选购的场次将在', 'home', false, false, null)}<span>{minutes}</span>
   {TLang('分钟内开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次', 'home', false, false, null)}
 </div>;
        } else {
          str = <div className={styles.tipsmsg}>
            {TLang('已开场提醒：您选购的场次', 'home', false, false, null)}

            <span>{TLang('已开场', 'home', false, false, null)}</span>，


            {TLang('继续购票可能出票时间较长且出票失败率高，建议选购下个场次', 'home', false, false, null)}
          </div>;
        }
        setMsgText(str);
        setShowMsg(true);
      }
    } else {
      setShowMsg(false);
    }
  }, [time]);
  return (
    <div className={styles.tips}>{msgText}</div>
  );
};
export default DFTipsMsg;
